// Date de naissance au format JJ/MM/AAAA (aussi JJ-MM-AAAA ou JJ.MM.AAAA).
// L'ancien format AAAA-MM-JJ reste accepté pour les fichiers déjà remplis.
// Renvoie la date au format AAAA-MM-JJ (format interne), ou "" si invalide.
export function parseBirthDate(value: string): string {
  const fr = value.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
  const iso = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);

  const parts = fr
    ? [fr[3], fr[2], fr[1]]
    : iso
      ? [iso[1], iso[2], iso[3]]
      : null;

  if (!parts) {
    return "";
  }

  const [year, month, day] = parts.map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));

  if (
    date.getUTCFullYear() !== year ||
    date.getUTCMonth() !== month - 1 ||
    date.getUTCDate() !== day
  ) {
    return "";
  }

  return date.toISOString().slice(0, 10);
}

export function parseExcelPaste(content: string) {

  const rows = content
    .trim()
    .split(/\r?\n/)
    .map(row => row.trim())
    .filter(row => row.length > 0);

  if (rows.length === 0) {
    return [];
  }

  return rows
    .filter(row => {

      const header =
        row.toLowerCase().replace(/\s/g, "");

      return !header.startsWith(
        "email;licence;nom;"
      );
    })
    .map(row => {

      const separator =
        row.includes("\t")
          ? "\t"
          : row.includes(";")
            ? ";"
            : ",";

      const cols = row
        .split(separator)
        .map(col => col.trim());

      return {
        email: cols[0] ?? "",
        licence: cols[1] ?? "",
        lastName: cols[2] ?? "",
        firstName: cols[3] ?? "",
        gender: cols[4] ?? "",
        nationality: cols[5] ?? "",
        birthDateRaw: cols[6] ?? "",
        birthDate: parseBirthDate(cols[6] ?? ""),
        category: cols[7] ?? "",
        clubNumber: cols[8] ?? "",
        clubName: cols[9] ?? "",
      };
    });
}